import { Component } from '@angular/core';
import { PageBase } from '../../base/page-base/page-base.component';

//TODO LATER: add additonal popup, where user can select the cookies to accept or dismiss
@Component({
    templateUrl: './cookie-policy.page.html',
    standalone: false,
})
export class CookiePolicyPage extends PageBase {}
